import React, { Fragment } from "react";
import {
    useParams
} from "react-router-dom";
import get from 'lodash/get'
import { useSelector } from "react-redux";
import { ID } from 'actions/Base';
import { store } from 'reducers/createStore';
import { formatDistance, parseISO, differenceInHours, format, isToday, isYesterday, getMonth, isValid } from 'date-fns';
import { sv, enUS } from 'date-fns/esm/locale';
import i18n from 'i18next'

import UserBadge from 'components/UserBadge/UserBadge.js';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import {
    primaryColor,
} from "assets/jss/material-kit-pro-react.js";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from '@mui/material/ListItemText';
import axios from 'utils/axios';
import {toastr} from 'react-redux-toastr'
import CustomText from "components/CustomText/CustomText.js";

// Icons
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import InventoryIcon from '@mui/icons-material/Inventory';

// Translation
import { useTranslation } from 'react-i18next'

// Interval
import { useInterval } from 'utils/hooks.js';

// Redux
import * as Metadata from 'actions/Metadata';
import * as Notifications from 'actions/Notifications';
import * as HitClub from 'actions/HitClub';

export function getDefaultDataFromBacked() {

    // States
    const authentication = store.getState().authentication
    const metadata = store.getState().list
    // const currentUserLanguage = store.getState().currentUser?.instance?.language

    // Hooks
    // const { i18n } = useTranslation();

    const {
        userIsLoggedIn,
        userType
    } = authentication || {
        userIsLoggedIn: false,
        userType: ''
    }


    // Functions
    // function pollNotifications(time) {
    //     useInterval(() => {
    //         store.dispatch(Notifications.onPollRequest());
    //     }, time);
    // }    

    // Get default values from backend 
    // useEffect(() => {
    if(!metadata?.length) {
        store.dispatch(Metadata.onGetRequest());
    }
    
    if(userIsLoggedIn) {
        store.dispatch(Notifications.onPollRequest()); // So we poll notifications if page reloaded
    }
    // Set language to defined language in backend (causes rerender bugs - needs to be rewritten)
    // if(currentUserLanguage !== undefined) {
    //     i18n.changeLanguage(currentUserLanguage);
    // }
    // }, []);

    // Poll for new notifications every five minutes (causes rerender bugs - needs to be rewritten)
    // if(userIsLoggedIn) {
    //     pollNotifications(300000);
    // }
}

export function GetCurrentUserId() {
    const currentUser = useSelector(state => state.currentUser.instance)
    return currentUser.studentId
}

export function CurrentUserHasLiked(likes, studentState) {

    const userLiked = likes.length && likes.find(i => get(i, 'student.id') === studentState.studentId);

    return userLiked;
}

export function GetCommentsForPost(commentsState, entityType, entityId) {
    return get(commentsState, `${ID({ entityType: entityType, entityId: entityId })}`, []);
};

export function IsOwner() {

    // States
    const currentUserCompanyId = store.getState().currentUser.instance.company?.companyId;
    const currentCompanyId = store.getState().company.companyProfile.companyId;

    const userCompanyId = currentUserCompanyId || 0
    const companyId = currentCompanyId || 0

    // Only to make code below more readable
    const loggedInUserCompanyId = userCompanyId.toString()
    const navigatedCompanyId = companyId.toString()

    if(loggedInUserCompanyId === navigatedCompanyId) {
        return true;
    }
    else {
        return false;
    }
}

export function IsHitMakerOwner(hitMakerId) {

    // States
    const currentUserId = store.getState().currentUser.instance.studentId;

    const userId = currentUserId || 0
    const selectedHitMakerId = hitMakerId || 0

    // Only to make code below more readable
    const loggedInUserId = userId.toString()
    const navigatedId = selectedHitMakerId.toString()

    if(loggedInUserId === navigatedId) {
        return true;
    }
    else {
        return false;
    }
}

export function IsLoggedInUser(userIdToTest) {

    // States
    const currentUser = store.getState().currentUser.instance;

    // Logged in user
    const {
        studentId,
    } = currentUser || {
        studentId: 0,
    };

    // Only to make code below more readable
    const loggedInUserId = studentId.toString()
    const idToTest = userIdToTest.toString()

    if(loggedInUserId === idToTest) {
        return true;
    }
    else {
        return false;
    }
}

export function getObjectKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
}

export function lowerCaseAllWordsExceptFirstLetters(string) {
    return string.replace(/\S*/g, function (word) {
        return word.charAt(0) + word.slice(1).toLowerCase();
    });
}

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function lowercaseFirstLetter(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}

export function convertNumberToEmployeesConstant(x) {

    // x = Number(num);

    if (x >= 0 && x <= 1) {
        return 'XS';
    }
    else if (x >= 1 && x <= 9) {
        return 'S';
    }
    else if (x >= 10 && x <= 49) {
        return 'M';
    }
    else if (x >= 50 && x <= 249) {
        return 'L';
    }
    else {
        return 'XL'
    }
}

export function getDateSeason() {
    const month = getMonth(new Date())+1;
    let season = '';
    switch(month.toString()) {
        case '12':
        case '1':
        case '2':
            season = 'winter';
        break;
        case '3':
        case '4':
        case '5':
            season = 'spring';
        break;
        case '6':
        case '7':
        case '8':
            season = 'summer';
        break;
        case '9':
        case '10': 
        case '11':
            season = 'fall';
        break;
    }
    return season;
}

//
// TODO: For handling revenueAmount, should be removed?
//
export function convertRevenueAmount(revenueAmount) {
    if(revenueAmount > 0 && revenueAmount < 1000000 ) {
        return "XS";
    }
    else if(revenueAmount > 1000000 && revenueAmount < 5000000 ) {
        return "S";
    }
    else if(revenueAmount > 5000000 && revenueAmount < 20000000 ) {
        return "M";
    }
    else if(revenueAmount > 20000000 && revenueAmount < 99000000 ) {
        return "L";
    }
    else if(revenueAmount > 99000000) {
        return "XL";
    }
} 

//
// Bitmask helpers for the app tour component
//

export function getTourStatusNameFromPath() {
    const currentPath = location.pathname.split("/")[1]

    switch (currentPath) {
        case "foretag": return "companyProfile"
        case "hitmanager": return "hitManager"
        case "hitsearch": return "hitSearch"
        default:
            break;
        }
}

export function getValuesFromTourBitmask(bitmask) {    

    let values = {
        "companyProfile" : false,
        "addReqProfile" : false,
        "hitManager" : false,
        "hitSearch" : false
    }
    
    if(bitmask & getTourBitmaskPositionFromObjectKey("companyProfile")) {
        values = { ...values, "companyProfile" : true }
    }
    if(bitmask & getTourBitmaskPositionFromObjectKey("addReqProfile")) {
        values = { ...values, "addReqProfile" : true }
    }
    if(bitmask & getTourBitmaskPositionFromObjectKey("hitManager")) {
        values = { ...values, "hitManager" : true }
    }
    if(bitmask & getTourBitmaskPositionFromObjectKey("hitSearch")) {
        values = { ...values, "hitSearch" : true }
    }

    return values;
    
}

export function getValueFromCurrentTourBitmaskByKey(objectKey) {    
    const storedBitmask = store.getState().currentUser.instance.takenTours;

    if(storedBitmask & getTourBitmaskPositionFromObjectKey(objectKey)) {
        return true;
    }
    else {
        return false;
    }
}

export function getTourBitmaskPositionFromObjectKey(objectKey) {
    switch (objectKey) {
        case "companyProfile" : return 0b1000
        case "addReqProfile" :  return 0b0100
        case "hitManager" :  return 0b0010
        case "hitSearch" :  return 0b0001
        default: return "Name not found";
    }    
}

export function setFalseValueOnTourBitmaskByKey(objectKey) {  
    const storedBitmask =  store.getState().currentUser.instance.takenTours;
    const bitmaskPosition = getTourBitmaskPositionFromObjectKey(objectKey);

    const x = bitmaskPosition; // input value
    const y = x.toString(2);
    const yl = y.length;
    const mask = (Math.pow(2,yl)-1); // calculate mask
    const invertedBitmaskPosition = ~x & mask;

    return storedBitmask & invertedBitmaskPosition;
}

export function setTrueValueOnTourBitmaskByKey(objectKey) {
    const storedBitmask =  store.getState().currentUser.instance.takenTours;
    const bitmaskPosition = getTourBitmaskPositionFromObjectKey(objectKey);
    
    return storedBitmask | bitmaskPosition
}

//
// END BITMASK
//

export const generateId = (length) => {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

export function arrayMove(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
};

export function validateURL(link)
{
	if(!!link) {
		if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
			return true;
		}
		else{
			return false;
		}
	}
}

export function renderDateTime(dateTime) {
    if(dateTime) {
        if (isToday(parseISO(dateTime))) {
            return i18n.t('general.dateTime.todayWithDate', { date: format(parseISO(dateTime), 'HH:mm')});
        }
        
        if (isYesterday(parseISO(dateTime))) {
            return i18n.t('general.dateTime.yesterdayWithDate', { date: format(parseISO(dateTime), 'HH:mm')});
        }
        
        return format(parseISO(dateTime), 'd LLL yyyy');
    }
    else {
        return ""
    }
}

export function renderAutomcompleteProductBasesTags(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option?.productBaseId}
              label={!!option?.value ? option?.value : option?.name}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              avatar={!!option?.value ? null : <Avatar alt={!!option?.value ? option?.value : option?.name} src={option?.image?.thumbnail||"dummy"} />}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutomcompleteProductOfferTags(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option.productOfferId}
              label={option.label}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              avatar={<Avatar alt={option.label} src={option?.productBase?.image?.thumbnail} />}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutomcompleteProductOfferTicketTags(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option.productOfferId}
              label={option.label}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              avatar={<ConfirmationNumberIcon />}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutomcompleteTags(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option.id}
              label={option.fullName}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              avatar={<Avatar alt={option.fullName} src={option.pictureUrl} />}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutomcompleteTagsHitClub(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option.id}
              label={option.hitClubName}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              avatar={<Avatar alt={option.hitClubName} src={option.logo.small} />}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutomcompleteTagsCompany(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option.id}
              label={option.companyName}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              avatar={<Avatar alt={option?.companyName} src={option?.pictureUrl} />}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutomcompleteTagsMembershipOffer(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option.id}
              label={option.name}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              avatar={<Avatar alt={option.name} src={option?.logo?.small} />}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutocompleteTagsWithoutAvatar(value, getTagProps) {
    return (
        value.map((option, index) => (
            <Chip
              key={option.id}
              label={option}
              color="primary"
              sx={{ m: 0.5 }}
              style={{backgroundColor: primaryColor[0]}}
              {...getTagProps({ index })}
            />
          ))
    )
}

export function renderAutcompleteAvatarOption(props, option) {
    return (
        <MenuItem {...props}>
            <UserBadge 
                avatar={option?.pictureUrl} 
                size='md'
                shadow={false}
                border={false}
                noMargins={true}
                name={option?.fullName}
                showName={true}
            />
        </MenuItem>
    )
}

export function renderAutcompleteAvatarOptionWithInstitution(props, option) {
    return (
        <MenuItem {...props}>
            <UserBadge 
                avatar={option?.pictureUrl} 
                size='md'
                shadow={false}
                border={false}
                noMargins={true}
                name={option?.fullName}
                title={option?.primaryInstitution?.institutionName}
                showName={true}
            />
        </MenuItem>
    )
}

export function renderAutcompleteCompanyOption(props, option) {
    return (
        <MenuItem {...props}>
            <UserBadge 
                avatar={option?.pictureUrl} 
                size='md'
                shadow={false}
                border={false}
                noMargins={true}
                name={option?.companyName}
                showName={true}
            />
        </MenuItem>
    )
}

export function renderAutcompleteAvatarOptionHitClub(props, option) {
    return (
        <MenuItem {...props} key={option.id}>
            <UserBadge 
                avatar={option?.logo.small} 
                size='md'
                shadow={false}
                border={false}
                noMargins={true}
                name={option?.hitClubName}
                title={option?.institution?.institutionName}
                showName={true}
            />
        </MenuItem>
    )
}

export function renderAutcompleteAvatarOptionMembershipOffer(props, option) {
    return (
        <MenuItem {...props}>
            <UserBadge 
                avatar={option?.logo?.small} 
                size='md'
                shadow={false}
                border={false}
                noMargins={true}
                name={option?.name}
                showName={true}
            />
        </MenuItem>
    )
}

export function renderAutcompleteProductBaseOption(props, option) {
    return (
        <MenuItem {...props} key={option.id}>
            <UserBadge 
                avatar={option?.image?.thumbnail} 
                size='md'
                shadow={false}
                border={false}
                noMargins={true}
                name={option?.name}
                showName={true}
            />
        </MenuItem>
    )
}

export function renderAutcompleteAddOption(props, option) {
    return (
        <MenuItem {...props} key={option.id}>
            <ListItemText style={{ textAlign: 'center' }}>{option?.name}</ListItemText>
        </MenuItem>
    )
}

export function renderAutcompleteProductOfferOption(props, option) {
    return (
        <MenuItem {...props}>
            <UserBadge 
                avatar={option?.productBase?.image?.thumbnail} 
                size='md'
                shadow={false}
                border={false}
                noMargins={true}
                name={option?.label}
                showName={true}
            />
        </MenuItem>
    )
}

export function renderAutcompleteProductOfferTicketOption(props, option) {
    return (
        <MenuItem {...props}>
            <CustomText> 
                {option?.label}
            </CustomText>
        </MenuItem>
    )
}

export async function downloadMembersList({hitClubId, hitMemberStatuses, search, fields, setLoading}) {
    setLoading(true);
    try {
        await axios({
            url: `/api/hitClub/v2/${hitClubId}/allHitMembersExcel?hitMemberStatuses=${hitMemberStatuses.value}${search.length > 1 ? `&q=${search}` : ""}${!!fields ? `&fields=${fields}` : ""}`,
            method: 'GET',
            responseType: 'blob', 
        }).then((response) => {
            toastr.success(i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.success.title'), i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.success.body'))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.fileName', { date: format(new Date(), "yyyyMMdd") })}.xlsx`);
            document.body.appendChild(link);
            link.click();
            setLoading(false);
        });
    } catch (e) {
        toastr.error(i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.error.title'), i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.error.body'))
        setLoading(false);
    }
}

export async function downloadGuestList(item) {
    try {
        await axios({
            url: `/api/dynamicInfo/${item.ticketTypeId}/getStudentDynamicInfo/excel`,
            method: 'GET',
            responseType: 'blob', 
        }).then((response) => {
            toastr.success(i18n.t('ticket.downloadQuestionFormExcel.success.title'), i18n.t('ticket.downloadQuestionFormExcel.success.body'))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${item.name.toString()} ${i18n.t('ticket.downloadQuestionFormExcel.buttonText')} ${format(new Date(), "yyyyMMdd")}.xlsx`);
            document.body.appendChild(link);
            link.click();
        });
    } catch (e) {
        toastr.error(i18n.t('ticket.downloadQuestionFormExcel.error.title'), i18n.t('ticket.downloadQuestionFormExcel.error.body'))
    }
}

export async function downloadGuestListAll(hitEventId, setDownloadGuestListAllLoading) {
    try {
        await axios({
            url: `/api/product/userProduct/excel?entityType=HIT_EVENT&entityId=${hitEventId}`,
            method: 'GET',
            responseType: 'blob', 
        }).then((response) => {
            toastr.success(i18n.t('ticket.downloadQuestionFormExcel.success.title'), i18n.t('ticket.downloadQuestionFormExcel.success.body'))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${i18n.t('ticket.downloadQuestionFormExcel.buttonTextAll')} ${format(new Date(), "yyyyMMdd")}.xlsx`);
            document.body.appendChild(link);
            link.click();
            !!setDownloadGuestListAllLoading && setDownloadGuestListAllLoading(false)
        });
    } catch (e) {
        toastr.error(i18n.t('ticket.downloadQuestionFormExcel.error.title'), i18n.t('ticket.downloadQuestionFormExcel.error.body'))
        !!setDownloadGuestListAllLoading && setDownloadGuestListAllLoading(false)
    }
}

export async function downloadHitCluProductSalesList(hitEventId) {
    try {
        await axios({
            url: `/api/product/userProduct/excel?entityType=HIT_CLUB&entityId=${hitEventId}`,
            method: 'GET',
            responseType: 'blob', 
        }).then((response) => {
            toastr.success(i18n.t('products.downloadHitCluProductSalesList.success.title'), i18n.t('products.downloadHitCluProductSalesList.success.body'))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${i18n.t('products.downloadHitCluProductSalesList.buttonTextAll')} ${format(new Date(), "yyyyMMdd")}.xlsx`);
            document.body.appendChild(link);
            link.click();
        });
    } catch (e) {
        toastr.error(i18n.t('products.downloadHitCluProductSalesList.error.title'), i18n.t('products.downloadHitCluProductSalesList.error.body'))
    }
}

export async function downloadHitClubPaymentReport(hitClubId) {
    try {
        await axios({
            url: `/api/hitPayments/paymentReport/${hitClubId}/pdf`,
            method: 'GET',
            responseType: 'blob', 
        }).then((response) => {
            toastr.success(i18n.t('payments.downloadHitClubPaymentReport.success.title'), i18n.t('payments.downloadHitClubPaymentReport.success.body'))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${i18n.t('payments.downloadHitClubPaymentReport.reportName')} ${format(new Date(), "yyyyMMdd")}.pdf`);
            document.body.appendChild(link);
            link.click();
        });
    } catch (e) {
        toastr.error(i18n.t('payments.downloadHitClubPaymentReport.error.title'), i18n.t('payments.downloadHitClubPaymentReport.error.body'))
    }
}

export function isPositiveInteger(v) {
    var i;
    return v && (i = parseInt(v)) && i > 0 && (i === v || ''+i === v);
  }
  
export function memberStatusChip(rowData, size="medium") {
    if(rowData.hitMemberStatus === "MEMBER") {
        return (<Chip size={size} color="success" icon={<CheckIcon />} label={i18n.t('hitClub.hitMembers.statuses.MEMBER_PAID')} />)
    }
    else if(rowData.hitMemberStatus === "MEMBER_PAID") {
        return (<Chip size={size} color="success" icon={<CheckIcon />} label={i18n.t('hitClub.hitMembers.statuses.MEMBER_PAID')} />)
    }
    else if(rowData.hitMemberStatus === "MEMBER_FREE") {
        return (<Chip size={size} color="success" icon={<CheckIcon />} label={i18n.t('hitClub.hitMembers.statuses.MEMBER_FREE')} />)
    }
    else if(rowData.hitMemberStatus === "NOT_MEMBER") {
        return (<Chip size={size} color="error" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.NOT_MEMBER')} />)
    }
    else if(rowData.hitMemberStatus === "PENDING_APPROVAL") {
        return (<Chip size={size} color="success" variant="outlined" icon={<VisibilityIcon />} label={i18n.t('hitClub.hitMembers.statuses.PENDING_APPROVAL_REQUEST')} />)
    }
    else if(rowData.hitMemberStatus === "PENDING_APPROVAL_REQUEST") {
        return (<Chip size={size} color="success" variant="outlined" icon={<VisibilityIcon />} label={i18n.t('hitClub.hitMembers.statuses.PENDING_APPROVAL_REQUEST')} />)
    }
    else if(rowData.hitMemberStatus === "PENDING_APPROVAL_USER_FEEDBACK") {
        return (<Chip size={size} color="success" variant="outlined" icon={<VisibilityIcon />} label={i18n.t('hitClub.hitMembers.statuses.PENDING_APPROVAL_USER_FEEDBACK')} />)
    }
    else if(rowData.hitMemberStatus === "CANCELLED_REQUEST") {
        return (<Chip size={size} color="error" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.CANCELLED_REQUEST')} />)
    }
    else if(rowData.hitMemberStatus === "PENDING_PAYMENT") {
        return (<Chip size={size} color="success" variant="outlined" icon={<VisibilityIcon />} label={i18n.t('hitClub.hitMembers.statuses.PENDING_PAYMENT')} />)
    }
    else if(rowData.hitMemberStatus === "PENDING_USER_FEEDBACK") {
        return (<Chip size={size} color="success" variant="outlined" icon={<VisibilityIcon />} label={i18n.t('hitClub.hitMembers.statuses.PENDING_USER_FEEDBACK')} />)
    }
    else if(rowData.hitMemberStatus === "CANCELLED_EXPIRED") {
        return (<Chip size={size} color="error" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.CANCELLED_EXPIRED')} />)
    }
    else if(rowData.hitMemberStatus === "CANCELLED_DECLINED") {
        return (<Chip size={size} color="error" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.CANCELLED_DECLINED')} />)
    }
    else if(rowData.hitMemberStatus === "CANCELLED_TERMINATED_BY_HITCLUB") {
        return (<Chip size={size} color="warning" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.CANCELLED_TERMINATED_BY_HITCLUB')} />)
    }
    else if(rowData.hitMemberStatus === "CANCELLED_BANNED") {
        return (<Chip size={size} color="error" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.CANCELLED_BANNED')} />)
    }
    else if(rowData.hitMemberStatus === "CANCELLED_TERMINATED_BY_USER") {
        return (<Chip size={size} color="warning" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.CANCELLED_TERMINATED_BY_USER')} />)
    }
    else if(rowData.hitMemberStatus === "DELETED") {
        return (<Chip size={size} color="error" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.DELETED')} />)
    }
    else if(rowData.hitMemberStatus === "PAID_NOT_MEMBER") {
        return (<Chip size={size} color="warning" icon={<CloseIcon />} label={i18n.t('hitClub.hitMembers.statuses.PRE_PAID_NO_APP')} />)
    }
    else if(rowData.hitMemberStatus === "PRE_PAID_HAS_APP") {
        return (<Chip size={size} color="success" icon={<CheckIcon />} label={i18n.t('hitClub.hitMembers.statuses.PRE_PAID_HAS_APP')} />)
    }
    else if(rowData.hitMemberStatus === "PRE_PAID_NO_APP") {
        return (<Chip size={size} color="success" icon={<CheckIcon />} label={i18n.t('hitClub.hitMembers.statuses.PRE_PAID_NO_APP')} />)
    }
    else if(rowData.hitMemberStatus === "MANUAL_CREATED") {
        return (<Chip size={size} color="success" icon={<CheckIcon />} label={i18n.t('hitClub.hitMembers.statuses.MEMBER_PAID')} />)
    }
}

export function getMinEventEndDate(ticketTypes) {
    if(!!ticketTypes && ticketTypes.length > 0) {
        const result = ticketTypes.reduce((r, o) => new Date(o.ticketEndDate) > new Date(r.ticketEndDate) ? o : r);
        return new Date(parseISO(result.ticketEndDate));
    }
    return new Date;
}


// Source: http://stackoverflow.com/questions/497790
export const dates = {
    convert:function(d) {
        // Converts the date in d to a date-object. The input can be:
        //   a date object: returned without modification
        //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
        //   a number     : Interpreted as number of milliseconds
        //                  since 1 Jan 1970 (a timestamp) 
        //   a string     : Any format supported by the javascript engine, like
        //                  "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
        //  an object     : Interpreted as an object with year, month and date
        //                  attributes.  **NOTE** month is 0-11.
        return (
            d.constructor === Date ? d :
            d.constructor === Array ? new Date(d[0],d[1],d[2]) :
            d.constructor === Number ? new Date(d) :
            d.constructor === String ? new Date(d) :
            typeof d === "object" ? new Date(d.year,d.month,d.date) :
            NaN
        );
    },
    compare:function(a,b) {
        // Compare two dates (could be of any type supported by the convert
        // function above) and returns:
        //  -1 : if a < b
        //   0 : if a = b
        //   1 : if a > b
        // NaN : if a or b is an illegal date
        // NOTE: The code inside isFinite does an assignment (=).
        return (
            isFinite(a=this.convert(a).valueOf()) &&
            isFinite(b=this.convert(b).valueOf()) ?
            (a>b)-(a<b) :
            NaN
        );
    },
    inRange:function(d,start,end) {
        // Checks if date in d is between dates in start and end.
        // Returns a boolean or NaN:
        //    true  : if d is between start and end (inclusive)
        //    false : if d is before start or after end
        //    NaN   : if one or more of the dates is illegal.
        // NOTE: The code inside isFinite does an assignment (=).
       return (
            isFinite(d=this.convert(d).valueOf()) &&
            isFinite(start=this.convert(start).valueOf()) &&
            isFinite(end=this.convert(end).valueOf()) ?
            start <= d && d <= end :
            NaN
        );
    }
}

export function isValidDate(date) {
    const parsed = parseISO(date, {locale: i18n.language === "sv" ? sv : enUS})
    console.log('dateIsValid?', date, isValid(parsed))
    return isValid(parsed)
}

export function moveItemInArray(array, from, to) {
    var f = array.splice(from, 1)[0];
    array.splice(to, 0, f);

    return array;
}

export async function downloadMecenatList({ setLoading }) {
    setLoading(true);
    try {
        await axios({
            url: `/api/hitMember/file1`,
            method: 'POST',
            responseType: 'blob', 
        }).then((response) => {
            toastr.success(i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.success.title'), i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.success.body'))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.file1Name', { date: format(new Date(), "yyyyMMdd") })}.txt`);
            document.body.appendChild(link);
            link.click();
            setLoading(false);
        });
    } catch (e) {
        toastr.error(i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.error.title'), i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.error.body'))
        setLoading(false);
    }
}

export async function downloadSssbList({ setLoading }) {
    setLoading(true);
    try {
        await axios({
            url: `/api/hitMember/file2`,
            method: 'POST',
            responseType: 'blob', 
        }).then((response) => {
            toastr.success(i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.success.title'), i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.success.body'))
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.file2Name', { date: format(new Date(), "yyyyMMdd") })}.txt`);
            document.body.appendChild(link);
            link.click();
            setLoading(false);
        });
    } catch (e) {
        toastr.error(i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.error.title'), i18n.t('hitClub.hitMembers.hitMembersList.downloadHitMembersList.error.body'))
        setLoading(false);
    }
}